import { useTranslation } from 'src/utils/i18n'

const NewProgress2 = ({ nowPage }) => {

    const { t } = useTranslation('commonAndroid')

    return (

        // 新ui
        <div className='mx-[22px] flex flex-col items-center'>
            <h2 className='text-[24px] text-center text-[#2B2D33] font-[600] leading-[32px] mb-[60px]'>{t('Configuration Process')}</h2>

            <ul>
                <li className='flex items-start'>
                    <span className={`w-[20px] h-[20px] text-[14px] font-[500] leading-[18px] flex justify-center items-center mr-2 ${nowPage === 2 ? 'bg-[#2A99FF] text-[#FFFFFF]' : 'text-[#222222]'} rounded-[10px]`}>1.</span>
                    <p className={`text-[16px] leading-[22px] ${nowPage === 2 ? 'font-[600]' : 'font-[400]'}`}>{t('Install app on target phone')}</p>
                </li>
                <li className='flex items-start mt-[30px]'>
                    <span className={`w-[20px] h-[20px] text-[14px] font-[500] leading-[18px] flex justify-center items-center mr-2 ${nowPage === 5 ? 'bg-[#2A99FF] text-[#FFFFFF]' : 'text-[#222222]'} rounded-[10px]`}>2.</span>
                    <p className={`text-[16px] leading-[22px] ${nowPage === 5 ? 'font-[600]' : 'font-[400]'}`}>{t('Configure in the target phone')}</p>
                </li>
                <li className='flex items-start mt-[30px]'>
                    <span className={`w-[20px] h-[20px] text-[14px] font-[500] leading-[18px] flex justify-center items-center mr-2 ${nowPage === 12 ? 'bg-[#2A99FF] text-[#FFFFFF]' : 'text-[#222222]'} rounded-[10px]`}>3.</span>
                    <p className={`text-[16px] leading-[22px] ${nowPage === 12 ? 'font-[600]' : 'font-[400]'}`}>{t('Verify successful')}</p>
                </li>
            </ul>
        </div>
    )
}

export default NewProgress2
